export const buildDefaultArray = (cols: any[], saved: any[]) => {
    const savedMap = saved.reduce((acc: any, item: any) => {
        acc[item.accessor] = item;
        return acc;
    }, {});
    return cols
        .filter((col: any) => col.accessorKey || col.name)
        .map((col: any) => {
            const accessor = col.accessorKey || col.name;
            return { accessor, hide: false, hideCompletely: false, hideSort: false, ...savedMap[accessor] };
        });
};

export const buildDefaultFilters = (filters: any[], saved: any[]) => {
    const savedMap = saved.reduce((acc: any, item: any) => {
        acc[item.accessor] = item;
        return acc;
    }, {});
    return filters
        .filter((filter: any) => filter.accessorKey || filter.name)
        .map((filter: any) => {
            const accessor = filter.accessorKey || filter.name;
            return { accessor, hide: false, ...savedMap[accessor] };
        });
};

export const flattenFilters = (filters: any[]) => filters.flatMap((filter: any) => {
    if (filter.children?.length > 0) {
        return filter.children.map((child: any) => ({
            ...child,
            name: `${filter.name}.${child.name}`,
        }));
    }
    return [filter];
});
